export interface OfferValidationResult {
  offerId: string;
  isValid: boolean;
  error?: string;
}

export function parseOfferIds(input: string): Array<string> {
  // input can be separated by new lines, commas, or spaces
  return input
    .split(/[\n, ]/)
    .map((id) => id.trim())
    .filter(Boolean);
}

export function findDuplicates(ids: Array<string>): Array<string> {
  const count = new Map<string, number>();
  ids.forEach((id) => count.set(id, (count.get(id) || 0) + 1));
  return Array.from(count.entries())
    .filter(([_, freq]) => freq > 1)
    .map(([id]) => id);
}

export function validateOfferId(offerId: string, existingOffers: Array<string>): OfferValidationResult {
  if (!offerId) {
    return { offerId, isValid: false, error: 'Offer ID cannot be empty' };
  }

  if (existingOffers.includes(offerId)) {
    return { offerId, isValid: false, error: 'Offer already exists in the list' };
  }

  return { offerId, isValid: true };
}
